var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6,32.4v7.2c0,3.3-3,6-6.8,6H9.2c-3.7,0-6.8-2.7-6.8-6v-7.2H0v7.2C0,44.2,4.1,48,9.2,48h29.7 c5,0,9.2-3.8,9.2-8.4v-7.2H45.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "36.8,21.2 35.2,19.6 25.2,29.5 25.2,0 22.8,0 22.8,29.5 12.8,19.6 11.2,21.2 24,34.1 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDownArrow);
export default __webpack_public_path__ + "static/media/download-down-arrow.2e0452f71b61f45b7f9c53e36fa92c20.svg";
export { ForwardRef as ReactComponent };